import React, { memo } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { FormattedMessage } from 'react-intl'
import ContactOptions from 'components/shared/ContactOptions'
import sx from './styles'

const Contact = ({
  className,
  title = 'CONTACT_TITLE',
  titleVariant = 'h3',
  titleComponent = 'p',
  description = 'CONTACT_DESCRIPTION',
  info = 'CONTACT_INFO',
  showInfo = true,
  showSubtitle = true,
  withBorder = false,
  variantPhone = 'sales',
  variantWhatsappPhone,
  whatsappMessage,
  // showWhatsapp = false,
  showWhatsapp = true, // TODO: Cambiar a true cuando quieran mostrar en todas las secciones
  showCallUs,
  customNumberPhone,
  sx: sxProp,
}) => {
  return (
    <Box
      className={className}
      sx={{ ...sx.root, ...sxProp }}
    >
      <Box sx={withBorder ? sx.withBorder : {}}>
        <Typography
          variant={titleVariant}
          component={titleComponent}
        >
          <FormattedMessage id={title} />
        </Typography>
        {showSubtitle && (
          <Typography
            variant="body1"
            sx={sx.description}
          >
            <FormattedMessage id={description} />
          </Typography>
        )}
        {showInfo && (
          <Typography
            variant="body1"
            mt={2}
            sx={sx.contactInfo}
          >
            <FormattedMessage id={info} />
          </Typography>
        )}
        <ContactOptions
          direction="row"
          sxProps={sx.contentBtn}
          variantPhone={variantPhone}
          showWhatsapp={showWhatsapp}
          showCallUs={showCallUs}
          variantWhatsappPhone={variantWhatsappPhone}
          whatsappMessage={whatsappMessage}
          containerStyle={sx.contactContainer}
          customNumberPhone={customNumberPhone}
          className="Contact-root"
        />
      </Box>
    </Box>
  )
}
export default memo(Contact)
